import React, { PropsWithChildren } from 'react';
import { VerticalMenu } from '@common/components';

export const SUPPLIER_ADMIN_MENU = {
  HOME: {
    LABEL: 'Admin',
    ROUTE: '/works/supplier/admin',
  },
  USERS: {
    LABEL: 'Users',
    ROUTE: '/works/supplier/admin/users',
  },
  DETAILS: {
    LABEL: 'Details',
    ROUTE: '/works/supplier/admin/details',
  },
};

type BaseProps = {
  hideMenu: boolean;
  children: React.ReactNode;
  permissions: {
    canShowAdminMembers: boolean;
  };
};

export function SupplierAdminVerticalNavMenu({
  permissions,
  hideMenu,
  children,
}: PropsWithChildren<BaseProps>) {
  const menuItems = [
    {
      name: SUPPLIER_ADMIN_MENU.DETAILS.LABEL,
      iconOfKind: { icon: 'hospital', kind: 'light' },
      redirectTo: SUPPLIER_ADMIN_MENU.DETAILS.ROUTE,
    },
    {
      name: SUPPLIER_ADMIN_MENU.USERS.LABEL,
      iconOfKind: { icon: 'users', kind: 'light' },
      redirectTo: SUPPLIER_ADMIN_MENU.USERS.ROUTE,
      canShow: permissions.canShowAdminMembers,
    },
  ];

  return (
    <VerticalMenu
      items={menuItems}
      menuKey="admin-settings-menu"
      hideMenu={hideMenu}
    >
      {children}
    </VerticalMenu>
  );
}
